import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TrinoLinkedService } from '../linkedservice/trino.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.trino.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Trino_FormalName),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Trino_FormalName)
    ],
    constraints: {
        linkedService: {
            model: TrinoLinkedService.MODEL // Linked service redefined
        }
    }
})
export class TrinoDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
